// @flow

import React from 'react';
import { Label, FormGroup } from 'reactstrap';

import { CustomRadioGroup } from '../../../../../components/FormikElements';

const TRIP_TYPE_OPTIONS = [
  { value: 'O', title: 'One Way' },
  { value: 'R', title: 'Round Trip' },
];

export default function FlightTypeInput() {
  return (
    <div className="radio-wrap">
      <Label className="sr-only">Trip</Label>
      <FormGroup>
        <CustomRadioGroup name="tripType" options={TRIP_TYPE_OPTIONS} />
      </FormGroup>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/SearchForm/FormElements/TripType.js